import localKey from './localKey'

const devApiUrl = '/';

// const proApiUrl = '//dev.fx.api.fxzb.vip/';
const proApiUrl = '//fx.api.fxzb.vip/';
// const proApiUrl = 'http://192.168.110.201:8102/'
// const proApiUrl = 'http://192.168.110.48:8128/'

const nodeDevEnv = process.env.NODE_ENV == 'development' ? true : false;

export default {
    nodeDevEnv: nodeDevEnv,
    apiUrl: nodeDevEnv ? devApiUrl : proApiUrl,
    siteName: '分销商后台',
    minSiteMame: 'C',
    version: "v1.0.0",
    apiPrefix: "",
    timeout: 10000,
    cookiesExpires: 7,
    requestRetry: 1,
    requestRetryDelay: 800,
    stationId:'stationId',
    tokenKey: 'Authorization',
    userInfoKey: 'USER_INFO',
    ...localKey
}